// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#clientRouter .el-form-item{display:flex;flex-wrap:wrap}#clientRouter .el-form-item__content{flex:1}#clientRouter .tip-text{text-align:left}#clientRouter .tip-text.false{color:red}", ""]);
// Exports
module.exports = exports;
